import '@fontsource/baloo-2/latin-800.css'
import '@fontsource/figtree/latin-400.css'
import '@fontsource/figtree/latin-500.css'
import '@fontsource/figtree/latin-600.css'
import '@fontsource/figtree/latin-700.css'
import './styles/global.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import { AppErrorBoundary } from './app/error-boundaries'
import { AppProviders } from './app/providers'
import { createAppRouter } from './app/router'
import { env } from './lib/config/env'
import { registerAppServiceWorker } from './lib/pwa/register'

// Platform-specific CSS (for example the Android chat bottom inset) needs a
// stable hook before the first paint. VITE_CLIENT_PLATFORM is baked in at build
// time, so this is known in the native APK.
document.documentElement.dataset.clientPlatform = env.clientPlatform

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

const router = createAppRouter()

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <AppErrorBoundary>
        <RouterProvider router={router} />
      </AppErrorBoundary>
    </AppProviders>
  </StrictMode>,
)

void registerAppServiceWorker()
